export const configurations: CMx.ConfigurationState = {
  configurations: [],
  configurationDetail: undefined,
  isDrawerOpen: false,
  isDrawerContentOpen: false
};
